/* Only the all-jewelry collection loads this controller. Catalog reads are public;
   product cards are rendered by Shopify Liquid in the visitor's existing session. */
(() => {
  const config = document.getElementById('IdiamondsCatalogConfig');
  if (!config) return;
  const root = config.closest('.shopify-section');
  root.dataset.idiamondsCatalog='';
  const grid = root.querySelector('#ProductGridContainer');
  const listTemplate = root.querySelector('#ProductsList').cloneNode(false);
  const size = Math.min(50, Number(config.dataset.pageSize) || 30);
  const sorts = {manual:['MANUAL',false], 'most-relevant':['COLLECTION_DEFAULT',false],
    'best-selling':['BEST_SELLING',false], 'price-ascending':['PRICE',false],
    'price-descending':['PRICE',true], 'title-ascending':['TITLE',false],
    'title-descending':['TITLE',true], 'created-ascending':['CREATED',false],
    'created-descending':['CREATED',true]};
  let definitions = [], controller, generation = 0, desiredUrl = new URL(location.href);
  const cache = new Map();
  const status = document.createElement('p');
  status.className='visually-hidden';
  status.setAttribute('role','status');
  status.setAttribute('aria-live','polite');
  root.querySelector('.collection__toolbar').after(status);
  const query = `query Catalog($first:Int,$last:Int,$after:String,$before:String,$filters:[ProductFilter!],$sort:ProductCollectionSortKeys!,$reverse:Boolean!) {
    collection(handle:"vezi-toate-produsele") { products(first:$first,last:$last,after:$after,before:$before,filters:$filters,sortKey:$sort,reverse:$reverse) {
      nodes { handle } pageInfo { hasNextPage hasPreviousPage startCursor endCursor }
      filters { id label type values { id label count input } }
    } }
  }`;
  function filtersFor(url) {
    const filters=[];
    for (const [key,value] of url.searchParams) {
      if (!key.startsWith('filter.')) continue;
      const definition=definitions.find(f=>f.id===key);
      const option=definition?.values.find(v=>valueFor(v)===value);
      if (option) filters.push(JSON.parse(option.input));
      else if(key.startsWith('filter.p.m.')) {
        const [, , , namespace,...parts]=key.split('.');
        filters.push({productMetafield:{namespace,key:parts.join('.'),value}});
      }
    }
    return filters;
  }
  function valueFor(option) {
    const input=JSON.parse(option.input);
    return input.productMetafield?.value ?? input.variantOption?.value ?? option.label;
  }
  async function products(url,signal,first=size) {
    const [sort,reverse]=sorts[url.searchParams.get('sort_by') || config.dataset.defaultSort] || sorts.manual;
    const backwards=url.searchParams.get('_direction')==='previous';
    const cursor=url.searchParams.get('_cursor');
    const variables={filters:filtersFor(url),sort,reverse,
      first:backwards?null:first,last:backwards?first:null,
      after:backwards?null:cursor,before:backwards?cursor:null};
    const response=await fetch(config.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({query,variables}),signal});
    if(!response.ok) throw Error('Catalog request failed');
    const payload=await response.json();
    if(payload.errors || !payload.data?.collection) throw Error('Catalog unavailable');
    return payload.data.collection.products;
  }
  function renderFilters(filters,url) {
    definitions=filters;
    for(const id of ['FacetFiltersContainer','DrawerFacetFiltersContainer']) {
      const container=root.querySelector('#'+id);
      if(!container) continue;
      let target=container;
      if(id==='DrawerFacetFiltersContainer') {
        target=container.querySelector('[data-catalog-filter-list]');
        if(!target) {target=document.createElement('div');target.dataset.catalogFilterList='';container.querySelector('.drawer__sticky').before(target);}
      }
      const opened=new Set([...target.querySelectorAll('details[open]')].map(d=>d.dataset.catalogFilter));
      const fragment=document.createDocumentFragment();
      filters.filter(f=>f.type==='LIST'||f.type==='BOOLEAN').forEach((filter,index)=>{
        const details=document.createElement('details');
        details.className='accordion-details facet-accordion-details';
        details.dataset.catalogFilter=filter.id;
        details.open=opened.has(filter.id)||index===0||url.searchParams.has(filter.id);
        const summary=document.createElement('summary');
        summary.className='accordion-details__summary flex items-center justify-between';
        const heading=document.createElement('span'); heading.className='h6'; heading.textContent=filter.label;
        summary.append(heading);
        details.append(summary);
        const body=document.createElement('div'); body.className='accordion-details__content parent-display flex flex-col gap-3';
        const values=document.createElement('ul'); values.className='grid gap-3'; body.append(values);
        filter.values.forEach(option=>{
          const item=document.createElement('li'); item.className='flex items-center gap-2';
          const input=document.createElement('input'); input.type='checkbox'; input.className='checkbox'; input.name=filter.id;
          input.value=valueFor(option); input.dataset.catalogInput='';
          input.checked=url.searchParams.getAll(filter.id).includes(input.value);
          input.disabled=option.count===0&&!input.checked;
          const label=document.createElement('label'); label.className='flex flex-grow justify-between items-center gap-1 text-subtext reversed-link';
          label.htmlFor=`${filter.id}-${option.id}`; input.id=label.htmlFor;
          const text=document.createElement('span'); text.className='reversed-link__text'; text.textContent=option.label;
          const count=document.createElement('span'); count.className='count'; count.textContent=option.count;
          label.append(text,count); item.append(input,label); values.append(item);
        });
        details.append(body); fragment.append(details);
      });
      target.replaceChildren(fragment);
    }
    const active=root.querySelector('#FacetFiltersActive');
    if (active) active.replaceChildren();
    let selected=0;
    for(const filter of filters) for(const value of url.searchParams.getAll(filter.id)) {
      selected++;
      const button=document.createElement('button'); button.type='button';
      if (!active) continue;
      button.className='btn btn--secondary'; button.textContent=`${value} ×`;
      button.dataset.removeFilter=filter.id; button.dataset.removeValue=value; active.append(button);
    }
    if(selected && active) {
      const clear=document.createElement('button'); clear.type='button'; clear.className='btn--link';
      clear.textContent='Șterge tot'; clear.dataset.catalogClear=''; active.append(clear);
    }
    root.querySelectorAll('facet-count').forEach(el=>{el.hidden=!selected;el.textContent=`(${selected})`;});
    root.querySelectorAll('select[name="sort_by"]').forEach(el=>{el.value=url.searchParams.get('sort_by')||config.dataset.defaultSort;});
  }
  function resultTotal(filters,url) {
    const active=[...url.searchParams.keys()].filter(key=>key.startsWith('filter.'));
    if (!active.length) return Number(config.dataset.count);
    const candidates=[];
    filters.forEach(filter=>{
      const values=url.searchParams.getAll(filter.id);
      if (!filter.values?.length) return;
      if (values.length) {
        const count=values.reduce((sum,value)=>sum+Number(filter.values.find(item=>valueFor(item)===value)?.count||0),0);
        if (count) candidates.push(count);
      } else {
        const count=filter.values.reduce((sum,value)=>sum+Number(value.count||0),0);
        if (count) candidates.push(count);
      }
    });
    return candidates.length ? Math.min(...candidates) : Number(config.dataset.count);
  }
  function pageTotal(filters,url) {
    return Math.max(1,Math.ceil(resultTotal(filters,url)/size));
  }
  function pageParts(total,current) {
    const values=[];
    for(let page=1;page<=total;page++) {
      if(page===1||page===total||Math.abs(page-current)<=1) values.push(page);
      else if(values[values.length-1]!=='…') values.push('…');
    }
    return values;
  }
  async function cards(handles,signal) {
    const batches=[];
    for(let i=0;i<handles.length;i+=15) batches.push(handles.slice(i,i+15));
    const pieces=await Promise.all(batches.map(async batch=>{
      const key=batch.join('|');
      if(cache.has(key))return cache.get(key);
      const url=new URL(config.dataset.searchUrl,location.origin);
      url.searchParams.set('view','idiamonds-cards');url.searchParams.set('q',key);url.searchParams.set('type','product');
      const response=await fetch(url,{signal});
      if(!response.ok)throw Error('Cards unavailable');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const result=doc.querySelector('[data-catalog-cards]');
      if(!result || result.textContent.includes('Liquid error'))throw Error('Cards unavailable');
      const html=result.innerHTML;cache.set(key,html);
      if(cache.size>40)cache.delete(cache.keys().next().value);
      return html;
    }));
    return pieces.join('');
  }
  async function serverCount(url,signal) {
    if (!filtersFor(url).length) return Number(config.dataset.count);
    const countUrl=new URL(location.pathname,location.origin);
    for (const [key,value] of url.searchParams) if (key.startsWith('filter.')) countUrl.searchParams.append(key,value);
    countUrl.searchParams.set('view','idiamonds-count');
    const response=await fetch(countUrl,{signal});
    if (!response.ok) return null;
    const count=Number((await response.text()).trim());
    return Number.isFinite(count)&&count>0?count:null;
  }
  function resetPage(url) {
    ['page','_cursor','_direction','section_id'].forEach(key=>url.searchParams.delete(key));return url;
  }
  async function update(url,{initial=false,history=true}={}) {
    desiredUrl = new URL(url);
    controller?.abort();controller=new AbortController();
    const signal=controller.signal,version=++generation;
    grid.setAttribute('aria-busy','true');status.className='visually-hidden';status.textContent='Se încarcă…';
    try {
      // Legacy links have page numbers without cursors. Resolve their cursor
      // before rendering rather than silently showing page one.
      if(!initial&&!url.searchParams.has('_cursor')&&Number(url.searchParams.get('page'))>1) {
        const traversal=new URL(url);traversal.searchParams.delete('page');
        for(let page=1;page<Number(url.searchParams.get('page'));page++) {
          const previous=await products(traversal,signal);
          if(!previous.pageInfo.hasNextPage)break;
          traversal.searchParams.set('_cursor',previous.pageInfo.endCursor);
        }
        if(traversal.searchParams.has('_cursor'))url.searchParams.set('_cursor',traversal.searchParams.get('_cursor'));
      }
      const result=await products(url,signal,initial?1:size);
      if(initial) {renderFilters(result.filters,url);status.textContent='';return;}
      const [html,exactCount]=await Promise.all([cards(result.nodes.map(p=>p.handle),signal),serverCount(url,signal)]);
      if(version!==generation)return;
      const list=listTemplate.cloneNode(false);list.innerHTML=html;
      list.querySelectorAll('[data-motion]').forEach(el=>{el.style.opacity='1';el.style.visibility='visible';});
      const pagination=document.createElement('nav');pagination.className='pagination text-center';pagination.setAttribute('aria-label','Paginare');
      const page=Math.max(1,Number(url.searchParams.get('page'))||1), total=exactCount?Math.max(1,Math.ceil(exactCount/size)):pageTotal(result.filters,url);
      const paginationList=document.createElement('ul');paginationList.className='pagination__list list-unstyled flex items-center flex-wrap justify-center';paginationList.setAttribute('role','list');pagination.append(paginationList);
      const addPage=(label,number,active=false)=>{const li=document.createElement('li');const link=document.createElement('a');link.className=`pagination__item${active?' pagination__item--current background-2':''}`;link.textContent=label;link.setAttribute('aria-label',`Pagina ${number}`);if(active){link.setAttribute('aria-current','page');link.setAttribute('aria-disabled','true');link.setAttribute('role','link');}else{const next=new URL(url);['page','_cursor','_direction'].forEach(key=>next.searchParams.delete(key));next.searchParams.set('page',String(number));link.href=next;link.dataset.catalogPage='';}li.append(link);paginationList.append(li);};
      if(result.pageInfo.hasPreviousPage){const next=new URL(url);['page','_cursor','_direction'].forEach(key=>next.searchParams.delete(key));next.searchParams.set('page',String(page-1));const li=document.createElement('li');const link=document.createElement('a');link.className='pagination__item pagination__item--previous';link.textContent='Anterior';link.href=next;link.dataset.catalogPage='';li.append(link);paginationList.append(li);}
      pageParts(total,page).forEach(part=>part==='…'?(()=>{const li=document.createElement('li');li.innerHTML='<span class="pagination__item">…</span>';paginationList.append(li);})():addPage(String(part),part,part===page));
      if(result.pageInfo.hasNextPage){const next=new URL(url);['page','_cursor','_direction'].forEach(key=>next.searchParams.delete(key));next.searchParams.set('page',String(page+1));const li=document.createElement('li');const link=document.createElement('a');link.className='pagination__item pagination__item--next';link.innerHTML='Următoarea <span aria-hidden="true">›</span>';link.href=next;link.dataset.catalogPage='';li.append(link);paginationList.append(li);}
      grid.replaceChildren(list,pagination);
      if(!result.nodes.length){const empty=document.createElement('p');empty.textContent='Nu există produse pentru filtrele selectate.';list.append(empty);}
      renderFilters(result.filters,url);
      const filtered=filtersFor(url).length>0, totalCount=exactCount||resultTotal(result.filters,url);
      root.querySelector('#ProductCount').textContent=filtered?`${totalCount} produse`:`${config.dataset.count} produse`;
      const visibleUrl=new URL(url);
      ['_cursor','_direction','section_id'].forEach(key=>visibleUrl.searchParams.delete(key));
      desiredUrl=visibleUrl;
      if(history)window.history.pushState({},'',visibleUrl);
      const switcher=root.querySelector('layout-switcher');
      if(switcher)switcher.onButtonClick(switcher.querySelector('.btn--active'));
      document.dispatchEvent(new CustomEvent('collection:rerendered'));
      status.textContent=result.nodes.length?`Pagina ${page}`:'';
    } catch(error) {
      if(error.name!=='AbortError') {
        status.className='catalog-error';
        status.textContent='Produsele nu au putut fi încărcate. ';
        const retry=document.createElement('button');retry.type='button';retry.className='btn--link';retry.textContent='Încearcă din nou';
        retry.onclick=()=>update(url,{initial,history});status.append(retry);
      }
    } finally {if(version===generation)grid.removeAttribute('aria-busy');}
  }
  root.addEventListener('change',event=>{
    const input=event.target;
    if(!input.matches('[data-catalog-input], select[name="sort_by"]'))return;
    event.preventDefault();event.stopImmediatePropagation();
    const url=resetPage(new URL(desiredUrl));
    if(input.name==='sort_by')url.searchParams.set('sort_by',input.value);
    else {
      const values=url.searchParams.getAll(input.name).filter(v=>v!==input.value);
      if(input.checked)values.push(input.value);
      url.searchParams.delete(input.name);values.forEach(v=>url.searchParams.append(input.name,v));
    }
    update(url);
  },true);
  root.addEventListener('click',event=>{
    const summary=event.target.closest('[data-catalog-filter] > summary');
    if(summary) {event.preventDefault();summary.parentElement.open=!summary.parentElement.open;return;}
    const target=event.target.closest('[data-remove-filter],[data-catalog-clear],[data-catalog-page],#ProductGridContainer .pagination a');
    if(!target)return;
    event.preventDefault();event.stopImmediatePropagation();
    let url=new URL(desiredUrl);
    if(target.matches('a'))url=new URL(target.href);
    else {
      resetPage(url);
      if(target.hasAttribute('data-catalog-clear'))[...url.searchParams.keys()].filter(k=>k.startsWith('filter.')).forEach(k=>url.searchParams.delete(k));
      else {const key=target.dataset.removeFilter;const values=url.searchParams.getAll(key).filter(v=>v!==target.dataset.removeValue);url.searchParams.delete(key);values.forEach(v=>url.searchParams.append(key,v));}
    }
    update(url);
  },true);
  window.addEventListener('popstate',()=>update(new URL(location.href),{history:false}));
  const url=new URL(location.href);
  update(url,{initial:!filtersFor(url).length&&!url.searchParams.has('_cursor'),history:false});
})();
